export let props = ['data', 'width']
export let model = {

}
export let computed = {
}
